/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Response } from '../../models/response';

export interface ApiIdentityEmailconsentUpdateAllEmailConsentsGet$Params {
}

export function apiIdentityEmailconsentUpdateAllEmailConsentsGet(http: HttpClient, rootUrl: string, params?: ApiIdentityEmailconsentUpdateAllEmailConsentsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
  const rb = new RequestBuilder(rootUrl, apiIdentityEmailconsentUpdateAllEmailConsentsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Response>;
    })
  );
}

apiIdentityEmailconsentUpdateAllEmailConsentsGet.PATH = '/api/identity/emailconsent/UpdateAllEmailConsents';
